import { Tag, Tooltip } from 'antd'
import React from 'react'
import { Text } from 'styles/reactnative'
import EntryTime from '../../../../../components/EntryTime'
import KrwPrice from '../../../../../components/KrwPrice'
import UserTag from '../../../../../components/UserTag'
import { TagWrap } from '../../../../../components/styles'
import { COLORS } from '../../../../../constants'
import UserInfoDisplay from './UserInfoDisplay'

export const PGWithdrawalTableColumn: any = (mutate, openModal) => {
	return [
		{
			title: '번호',
			dataIndex: 'id',
			align: 'center',
			width: 70,
			render: (text, data) => <Text>{text}</Text>,
		},
		{
			title: '요청일시',
			dataIndex: 'created_at',
			align: 'center',
			width: 130,
			render: (text, data) => <EntryTime time={text} offset={9}/>,
		},
		{
			title: '처리일시',
			dataIndex: 'updated_at',
			width: 130,
			align: 'center',
			render: (text, data) => {
				{
					return text ? <EntryTime time={text} offset={9}/> : <Text>-</Text>
				}
			},
		},
		{
			title: '로그인 ID',
			dataIndex: 'user_id',
			width: 120,
			align: 'center',
			render: (text, data) => <UserInfoDisplay userId={data?.user_id} type="loginid" />,
		},
		{
			title: '실명',
			dataIndex: 'user_id',
			width: 100,
			align: 'center',
			render: (text, data) => <UserInfoDisplay userId={data?.user_id} type="fullname" />,
		},
		{
			title: '상태',
			dataIndex: 'status',
			width: 100,
			align: 'center',
			render: (text, data) => (
				<TagWrap>
					{text == 'PENDING' ? (
						<Tag
							style={{
								backgroundColor: '#f79336',
								color: 'white',
							}}>
							처리대기
						</Tag>
					) : text == 'APPROVED' ? (
						<Tag
							style={{
								backgroundColor: COLORS.lightGreen,
								color: 'white',
							}}>
							승인됨
						</Tag>
					) : text == 'REJECTED' ? (
						<Tag
							style={{ backgroundColor: '#ff4d4f', color: 'white' }}>
							거절됨
						</Tag>
					) : text == 'CANCELLED' ? (
						<Tag style={{ color: 'red' }}>취소됨</Tag>
					) : text == 'COMPLETED' ? (
						<Tag
							style={{
								backgroundColor: COLORS.lightGreen,
								color: 'white',
							}}>
							완료됨
						</Tag>
					) : (
						<Tag>대기중</Tag>
					)}
				</TagWrap>
			),
		},
		{
			title: '금액',
			dataIndex: 'amount',
			align: 'center',
			sorter: (a, b) => parseFloat(a.amount) - parseFloat(b.amount),
			render: (text, data) => <KrwPrice price={parseFloat(text) || 0} dp={0} />,
		},
		{
			title: '주문번호',
			dataIndex: 'order_id',
			align: 'center',
			render: (text, data) => {
				return (
					<Tooltip title={text}>
						<Text
							style={{
								maxWidth: 150,
								overflow: 'hidden',
								textOverflow: 'ellipsis',
								whiteSpace: 'nowrap',
							}}>
							{text || '-'}
						</Text>
					</Tooltip>
				)
			},
		},
		{
			title: 'PG사',
			dataIndex: 'pg_provider',
			align: 'center',
			width: 100,
			render: (text, data) => <Text>{text?.toUpperCase() || '-'}</Text>,
		},
		{
			title: 'PG 거래ID',
			align: 'center',
			dataIndex: 'pg_tid',
			render: (text, data) => {
				return (
					<Tooltip title={text}>
						<Text
							style={{
								maxWidth: 150,
								overflow: 'hidden',
								textOverflow: 'ellipsis',
								whiteSpace: 'nowrap',
							}}>
							{text || '-'}
						</Text>
					</Tooltip>
				)
			},
		},
		{
			title: '관리자 메모',
			align: 'center',
			dataIndex: 'data',
			render: (text, data) => {
				const adminNote = data?.data?.admin_note;
				return (
					<Tooltip title={adminNote}>
						<Text
							style={{
								maxWidth: 200,
								overflow: 'hidden',
								textOverflow: 'ellipsis',
								whiteSpace: 'nowrap',
								color: data?.status === 'REJECTED' ? '#ff4d4f' : 'inherit',
							}}>
							{adminNote || '-'}
						</Text>
					</Tooltip>
				)
			},
		},
	]
}

export default PGWithdrawalTableColumn
